import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Button, Typography, Alert } from "antd";
import { AppDispatch, RootState } from "../../redux/store";
import { login } from "../../redux/slices/authSlice";
import { Link, useNavigate } from "react-router-dom";

const { Title } = Typography;

export function Login() {
  const dispatch = useDispatch<AppDispatch>();
  const { loading, error } = useSelector((state: RootState) => state.auth);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const onFinish = async (values: any) => {
    // ✅ Backend expects Username + Password (capitalized)
    const payload = {
      Username: (values.username || "").trim(),
      Password: (values.password || "").trim(),
    };

    try {
      const resultAction = await dispatch(login(payload as any));

      if (login.fulfilled.match(resultAction)) {
        const user = resultAction.payload;

        if (user.isAdmin) {
          navigate("/resellers");
        } else if (user.isEsimReseller) {
          navigate("/");
        } else {
          navigate("/assign-sim-package");
        }
      }
    } catch (err) {
      console.error("Login failed:", err);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__header">
        <img src="/teltrip-logo.png" alt="Teltrip" className="login-page__logo" />
      </div>

      <div className="login-page__content">
        <div className="login-page__panel">
          <Link to="/" className="login-page__back">
            <span className="login-page__back-icon">{"<"}</span>
            Back
          </Link>

          <div className="login-card">
            <Title level={3} className="login-card__title">
              POS Login
            </Title>

            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item
                name="username"
                label="Username"
                rules={[{ required: true, message: "Please input your username!" }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true, message: "Please input your password!" }]}
              >
                <Input.Password />
              </Form.Item>

              {error && (
                <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />
              )}

              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} block>
                  Login
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>

      <div className="login-page__footer">
        Copyright {year} Teltrip eSIM. All rights reserved.
      </div>
    </div>
  );
}

export default Login;
